

 const useFunctions = (
)=> {

 

 

  function groupMenuExploreItems(menuItems: any) {
    const groupedItems = menuItems?.reduce((acc: any, currentItem: any) => {
      if (currentItem?.isSpecial) {
        const existingGroup = acc?.find(
          (group: any) => group?.title === currentItem?.specialName
        );
        if (existingGroup) {
          if (
            !existingGroup?.displayType &&
            currentItem?.digiMenuMedia?.[0]?.tag
          )
            existingGroup.displayType = currentItem?.digiMenuMedia?.[0]?.tag;
          existingGroup.content.push({
            image: currentItem?.digiMenuMedia && currentItem?.digiMenuMedia,
            dishName: currentItem?.itemName,
            menuData: currentItem,
          });
        } else {
          acc.push({
            title: currentItem?.specialName,
            displayType: currentItem?.digiMenuMedia?.[0]?.tag,
            desc: currentItem?.categoryDescription,
            content: [
              {
                image: currentItem?.digiMenuMedia && currentItem?.digiMenuMedia,
                dishName: currentItem?.itemName,
                menuData: currentItem,
              },
            ],
          });
        }
      }
      return acc;
    }, []);

    return groupedItems;
  }




  return {groupMenuExploreItems};
};


export default useFunctions;